import React,{useEffect,useState} from 'react';

/** Bek 2026-10-25: "still i cant change decision ... and on hover still not playing" — the fix was live; his tab was
 *  still running the console it had loaded before the deploy, the third time that has looked like a broken fix. The
 *  page is always current (Cloudflare Pages serves index.html with max-age=0); an open tab is not, because the console
 *  only ever re-fetches data. So the tab now notices: while visible it compares, once a minute, the entry bundle the
 *  live index.html names with the one it is running. When they differ it says so with a Reload button, and coming back
 *  to the tab reloads it by itself — unless a reason or note is half-written, which a reload would throw away. */
const bundle=/static\/js\/main\.[0-9a-f]+\.js/;
export const bundleOf=(text:string)=>text.match(bundle)?.[0]??null;
export const runningBundle=()=>bundleOf(Array.from(document.scripts).map(s=>s.src).find(src=>bundle.test(src))??'');
/** Anything typed that a reload would lose: a non-empty textarea, or the field being typed in. */
export const somethingHalfWritten=()=>Array.from(document.querySelectorAll('textarea')).some(t=>t.value.trim().length>0)
  ||(document.activeElement instanceof HTMLInputElement&&document.activeElement.value.trim().length>0);

export default function VersionWatcher({intervalMs=60000}:{intervalMs?:number}){
  const [stale,setStale]=useState(false);
  useEffect(()=>{
    const mine=runningBundle();
    if(!mine)return; // the dev server has no hashed bundle to compare
    let closed=false;
    const check=async()=>{
      if(document.hidden)return;
      try{
        const response=await fetch(`/index.html?v=${Date.now()}`,{cache:'no-store'});
        const live=response.ok?bundleOf(await response.text()):null;
        if(!closed&&live&&live!==mine)setStale(true);
      }catch{/* offline or mid-deploy: ask again next time */}
    };
    const timer=setInterval(()=>void check(),intervalMs);
    const onVisible=()=>{if(!document.hidden)void check();};
    document.addEventListener('visibilitychange',onVisible);
    return()=>{closed=true;clearInterval(timer);document.removeEventListener('visibilitychange',onVisible);};
  },[intervalMs]);
  useEffect(()=>{
    if(!stale)return;
    const onVisible=()=>{if(!document.hidden&&!somethingHalfWritten())window.location.reload();};
    document.addEventListener('visibilitychange',onVisible);
    return()=>document.removeEventListener('visibilitychange',onVisible);
  },[stale]);
  if(!stale)return null;
  return <div role='status' className='fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 px-4 py-2.5 rounded-xl bg-white border shadow-lg text-sm text-gray-800'>
    <span>A new version of the console is out. Reload to use it.</span>
    <button className='px-3 py-1.5 rounded-lg text-white font-semibold bg-gradient-to-r from-[#FF9C15] to-[#F42026] hover:opacity-90'
      onClick={()=>window.location.reload()}>Reload</button>
  </div>;
}
